import React from 'react'
import styles from './DragAndDropOverlay.sass'
import UploadBarViewModel from 'documents/views/DocumentRoot/UploadBar/UploadBarViewModel'
import { observer } from 'mobx-react'
import Job from 'jobs/Job'

interface DragAndDropProps {
  vm: UploadBarViewModel
  targetJob: Job
  onViewClick?: () => void
}

export default observer(({ vm, targetJob, onViewClick }: DragAndDropProps) => {
  if (vm.hidden) {
    return <></>
  }

  if (vm.dragging) {
    return <DraggingOverlay targetJob={targetJob} />
  }

  return (
    <div className={styles.container}>
      {vm.uploading && (
        <UploadBar>
          <div className={styles.text}>
            Uploading {vm.currentlyUploadingFile?.name}
            <span className={styles.remainingCount}>
              &nbsp;
              {vm.uploadQueueFiles.length} documents left
            </span>
          </div>
        </UploadBar>
      )}
      {vm.resolved && vm.successUploads.length > 0 && (
        <UploadBar>
          <div className={styles.text}>
            {vm.successUploads.length > 1 && (
              <>
                Uploaded {vm.successUploads.length} files to{' '}
                {targetJob.displayName}
              </>
            )}
            {vm.successUploads.length === 1 && (
              <>
                Uploaded {vm.successUploads[0]?.file.name} to{' '}
                {targetJob.displayName}
              </>
            )}
          </div>
          {onViewClick && (
            <div className={styles.action}>
              <a className={styles.viewButton} onClick={onViewClick}>
                VIEW
              </a>
            </div>
          )}
        </UploadBar>
      )}
    </div>
  )
})

interface UploadBarProps {
  children: React.ReactNode
}

const UploadBar = ({ children }: UploadBarProps) => {
  return <div className={styles.uploadBar}>{children}</div>
}

interface DraggingOverlayProps {
  targetJob: Job
}

const DraggingOverlay = ({ targetJob }: DraggingOverlayProps) => {
  return (
    <div className={styles.dragAndDropOverlay}>
      <img
        className={styles.dragAndDropImage}
        src={require('assets/images/img_drag-drop.svg')}
      ></img>
      <h2 className={styles.dragAndDropTitle}>
        Upload to {targetJob.displayName}
      </h2>
      <p className={styles.dragAndDropDescription}>
        Drag and drop your files anywhere on the screen to intiate file upload.
      </p>
    </div>
  )
}
